import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";

const DeleteFormModal = ({ isOpen, formName, onClose, onDelete }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed w-screen h-screen left-0 top-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <OutsideClickHandler onOutsideClick={onClose}>
        <div className="w-[436px] bg-[#FDEDED] rounded-[6px] flex flex-col">
          <div className="border-b-[1px] border-borderColor py-3 px-4">
            <p className="text-[16px] font-OpenSansMedium font-[600] text-titleColor">
              DELETE FORM
            </p>
          </div>

          <div className="p-[18px]">
            <p className="text-[12px] font-OpenSansMedium font-[500] text-titleColor text-center mb-4">
              Are you sure you want to delete this form?
            </p>

            <p className="text-[20px] leading-[36px] font-OpenSansMedium font-[700] text-black text-center mb-6 break-words">
              {formName || "-"}
            </p>

            <div className="w-full mt-3">
              <div className="flex items-center justify-between gap-4">
                <div
                  onClick={onClose}
                  className="w-[50%] h-[30px] text-[10px] rounded-[6px] border-[1px] border-subTitleColor flex items-center justify-center text-subTitleColor cursor-pointer"
                >
                  CANCEL
                </div>
                <div
                  onClick={onDelete}
                  className="w-[50%] h-[30px] text-[10px] rounded-[6px] flex items-center justify-center bg-[#de2c25] text-white cursor-pointer"
                >
                  DELETE
                </div>
              </div>
            </div>
          </div>
        </div>
      </OutsideClickHandler>
    </div>
  );
};

export default DeleteFormModal;
